import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyA47uEemh9DLl9BCEVeJuDdLzfl8OhS7Xg",
  authDomain: "realchat-bf993.firebaseapp.com",
  projectId: "realchat-bf993",
  storageBucket: "realchat-bf993.appspot.com",
  messagingSenderId: "973760746763",
  appId: "1:973760746763:web:a2a6d022a62b6d83fafe0e"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth();
export const storage = getStorage();
export const db = getFirestore();
